import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Contact from '../components/ContactUs/Contact'
import CustomizedSnackbar from '../components/CustomizedSnackbars/CustomizedSnackbar'
import Footer from '../components/Footer/Footer'
import FooterMobile from '../components/Footer/FooterMobile'
import Navbar from '../components/Navbar/Navbar'
import SetupStepRealEstate from '../components/SetupSteps/SetupStepRealEstate'
import HeroImage from '../assets/images/ML_business_servises_realestateadvisory_1_screen.jpg'
import Image from "../assets/images/ML_business _servises_realestateadvisory_img.jpg";
import HeroBusiness from '../components/HeroLandingPage/HeroBusiness'
import BusinessMessage from '../components/BusinessMessage/BusinessMessage'
import Step1 from '../assets/images/Step1.svg'
import Step2 from '../assets/images/Step2.svg'
import Step3 from '../assets/images/Step3.svg'
import Step4 from '../assets/images/Step4.svg'
import Step5 from '../assets/images/Step5.svg'
import Step6 from '../assets/images/Step6.svg'
const TabletBreakpoint = 1024;


const text = [
  {text:'Evaluating or completing an acquisition or sale',img:Step1}, 
  {text:'Capital allocation strategies',img:Step2},
  {text:'Consulting and Strategic Guidance',img:Step3},
  {text:'Sparing of Risk Evaluation',img:Step4},
  {text:'Investment Strategy on Developing or Renovating',img:Step5},
  {text:'Personalized Solutions and Portfolio Optimization',img:Step6}
  ]

const BusinessServiceRealEstate = () => {
  const [offset, setOffset] = useState(0);
  const [width, setWidth] = useState(window.innerWidth)
  const [background,setBackground] = useState('transparent')
  useEffect(()=>{
    window.addEventListener("resize", () => setWidth(window.innerWidth));
    window.scrollTo(0, 0)
  },[])
  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
    
}, []);
useEffect(()=>{
  if (offset>100) setBackground('#12284C')
  else setBackground('transparent')
},[offset])
  return (
    <div>
      <Navbar background={background}/>
        <HeroBusiness heroImage={HeroImage}
        header='We Provide Top Notch Advisory on Real Estate!'
        desc='With professional advice from our reliable advisory services, you may maximize the potential of your real estate endeavors.'
        />
        <BusinessMessage
  header="Add value to your real estate portfolio"
  desc="Welcome to Modern Living, your reliable partner in real estate advisory services. We are experts in offering strategic advice, in-depth analysis, and individualized solutions to support your decision-making in the dynamic real estate market.$We are well aware that real estate transactions can be difficult and complicated. Whether you're a developer, a business organization, or an individual investor, our team of skilled specialists is ready to assist you with thorough advice services catered to your individual requirements and plans."
  img={Image}
  desc2={`Our advisory team is made up of seasoned professionals with extensive knowledge of the real estate business and other relevant fields. To give you timely and accurate insights, we stay ahead of the curve by closely monitoring market trends, economic data, and regulatory changes.\n\nYou have access to a broad spectrum of skills when you choose our consulting services, including market analysis, financial analysis, due diligence, risk assessment, and portfolio optimization. We collaborate closely with you to gain a thorough understanding of your goals before creating a tailored plan to support you in achieving them. To assist you in reaching your real estate objectives, we offer strategic insights, individualized solutions, and thorough analysis.\n\nOur method is client-focused and collaborative. We support the development of solid relationships based on open communication, honesty, and trust. Our team takes the time to hear your worries, respond to your inquiries, and handle any potential problems. We take care in providing you with brief, simple-to-understand information so you can make wise decisions.\n\nOur consulting services are created to help you every step of the way, whether you're trying to buy or sell properties, evaluate investment opportunities, examine development projects, or maximize your real estate portfolio. For you to get the most out of your investment and avoid potential pitfalls, we navigate complexity, pinpoint risks, and identify opportunities.\n\nYou may feel at ease knowing that you have a committed partner on your side when you choose Modern Living as your real estate advisor. We stand out because of our dedication to excellence, rigorous attention to detail, and uncompromising professionalism. We base our success on your accomplishments, and we're committed to assisting you in achieving your real estate goals.\n\nStart now to realize the full potential of your real estate endeavors. Get in touch with us right now to find out more about how our consulting services can enhance your real estate plans and guarantee your success in this dynamic market.`}
/>
<SetupStepRealEstate data={text} header = "What we do in Real Estate Advisory?"/>

        <Contact displaymsg='block' displayupload = 'none'/>
        {width < TabletBreakpoint?<FooterMobile/>:<Footer/>}
        <CustomizedSnackbar/>
    </div>
  )
}

export default BusinessServiceRealEstate